const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://rsvp-backend-iwyf.onrender.com";

export default API_BASE_URL;
